export default {
  ncm: 'NCM',
  'ncm.domain.code': 'Code',
  'ncm.domain.description': 'Description',
  'ncm.domain.cest': 'CEST',
  'ncm.domain.taxesPercentage': 'Tribute Percentage',
  'ncm.domain.modalityDeterminationBcIcms': 'Type of BC ICMS Determination',
  'ncm.domain.modalityDeterminationBcIcms.0': '0 - Margem Valor Agregado (%)',
  'ncm.domain.modalityDeterminationBcIcms.1': '1 - Pauta (Valor)',
  'ncm.domain.modalityDeterminationBcIcms.2': '2 - Preço Tabelado Máx. (valor)',
  'ncm.domain.modalityDeterminationBcIcms.3': '3 - Valor da operação',
  'ncm.domain.cstIcms': 'CST ICMS',
  'ncm.domain.csosnIcms': 'CSOSN ICMS',
  'ncm.domain.aliquotIcms': '(%) Aliquot ICMS',
  'ncm.domain.mva': '(%) MVA',
  'ncm.domain.reductionIcms': '(%) ICMS Reduction Percentage',
  'ncm.domain.cstPis': 'CST PIS',
  'ncm.domain.aliquotPis': '(%) Aliquot PIS',
  'ncm.domain.cstCofins': 'CST COFINS',
  'ncm.domain.aliquotCofins': '(%) Aliquot COFINS',
  'ncm.domain.aliquotIpi': '(%) Aliquot IPI',
  'ncm.domain.cstIpi': 'CST IPI',
  'ncm.domain.cstIcmsEntry': 'CST ICMS',
  'ncm.domain.cstIpiEntry': 'CST IPI',
  'ncm.domain.cstPisEntry': 'CST PIS',
  'ncm.domain.cstCofinsEntry': 'CST COFINS',

  'ncm.outgoing': 'Outgoing',
  'ncm.incoming': 'Incoming',
  'ncm.icms/csosn': 'ICMS/CSOSN',
  'ncm.pis/cofins': 'PIS/COFINS',
  'ncm.ipi': 'IPI',
  'ncm.is': 'IS',
  'ncm.ibsCbs': 'IBS/CBS',

  'ncm.create': 'Create NCM',
  'ncm.create.new': 'New NCM',
  'ncm.create.notification.success': 'Success',
  'ncm.create.notification.successDescription': 'NCM created.',

  'ncm.update': 'Update NCM',
  'ncm.update.notification.success': 'Success',
  'ncm.update.notification.successDescription': 'NCM updated.',

  'ncm.remove': 'Remove NCM',
  'ncm.remove.alert': 'Do you really want to remove the NCM:',
  'ncm.remove.notification.success': 'Success',
  'ncm.remove.notification.successDescription': 'NCM removed.',

  'ncm.generateReport': 'Generate Report',

  'ncm.modal.report.title': 'Generate Report',
  'ncm.modal.report.buttons.viewReport': 'View Report',
  'ncm.modal.report.buttons.pdf': 'Generate PDF',
  'ncm.modal.report.buttons.rtf': 'Generate RTF',
  'ncm.modal.report.buttons.csv': 'Generate CSV',
  'ncm.modal.report.form.description': 'Description',
  'ncm.modal.report.form.codeNcm': 'NCM Code',

  'ncm.error.alreadyExists': 'NCM already exists!',

  'ncm.status.message.success': 'NCM Status Changed Successfully!',
};
